import { Table, Space, Button } from 'antd';
import type { ColumnType } from 'antd/es/table';
import { ReloadOutlined, FileExcelOutlined } from '@ant-design/icons';
import { utils, writeFile } from 'xlsx';
import dayjs from 'dayjs';

type NoOrderItem = {
  driverCode: string | null;
  providerName: string;
  buildingCode: number;
  buildingName: string;
};

type ScheduleNoOrderItemsComponentProps = {
  items: NoOrderItem[];
  isLoading: boolean;
  updatedAt: number | null;
  onRefresh: () => void;
};

const columns: ColumnType<NoOrderItem>[] = [
  {
    title: '司機代號',
    dataIndex: 'driverCode',
    key: 'driverCode',
    width: 100,
    align: 'center',
    render: (value: string | null) => value ?? '—',
  },
  {
    title: '餐廳名稱',
    dataIndex: 'providerName',
    key: 'providerName',
  },
  {
    title: '大樓代號',
    dataIndex: 'buildingCode',
    key: 'buildingCode',
    width: 90,
    align: 'center',
  },
  {
    title: '大樓名稱',
    dataIndex: 'buildingName',
    key: 'buildingName',
  },
];

function exportToExcel(items: NoOrderItem[], updatedAt: number | null) {
  const date = dayjs().format('YYYY-MM-DD');
  const updatedAtStr = updatedAt
    ? dayjs(updatedAt).format('YYYY-MM-DD HH:mm:ss')
    : '';

  const rows = items.map((item) => ({
    司機代號: item.driverCode ?? '',
    餐廳名稱: item.providerName,
    大樓代號: item.buildingCode,
    大樓名稱: item.buildingName,
  }));

  if (updatedAtStr) {
    rows.push({
      司機代號: `最後更新：${updatedAtStr}`,
      餐廳名稱: '',
      大樓代號: '' as any,
      大樓名稱: '',
    });
  }

  const wb = utils.book_new();
  const ws = utils.json_to_sheet(rows);
  utils.book_append_sheet(wb, ws, '今日零訂單出餐');
  writeFile(wb, `今日零訂單出餐_${date}.xlsx`);
}

export function ScheduleNoOrderItemsComponent(
  props: ScheduleNoOrderItemsComponentProps
) {
  return (
    <Space direction="vertical" className="w-full">
      <div className="flex items-center justify-between">
        <Space direction="vertical" size={0}>
          <span className="text-2xl font-bold">今日零訂單出餐</span>
          {props.updatedAt && (
            <span className="text-gray-400 text-sm">
              最後更新：{dayjs(props.updatedAt).format('HH:mm:ss')}
            </span>
          )}
        </Space>
        <Space>
          <Button
            icon={<FileExcelOutlined />}
            onClick={() => exportToExcel(props.items, props.updatedAt)}
            disabled={props.isLoading || props.items.length === 0}
          >
            匯出 Excel
          </Button>
          <Button
            icon={<ReloadOutlined />}
            onClick={props.onRefresh}
            loading={props.isLoading}
          >
            重新整理
          </Button>
        </Space>
      </div>
      <Table
        columns={columns}
        dataSource={props.items}
        loading={props.isLoading}
        rowKey={(record) => `${record.buildingCode}-${record.providerName}`}
        size="small"
        pagination={false}
        locale={{ emptyText: '今天所有路線皆有訂單' }}
        scroll={{ x: 'max-content' }}
      />
    </Space>
  );
}
